module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGOfPtRkwAAACBjSFJNAACHDwAAjA8AAP1SAACBQAAAfXkAAOmLAAA85QAAGcxzPIV3AAAACXBIWXMAAAsSAAALEgHS3X78AAABC0lEQVRYR+2WSxLDIAiG22v2dFn0llkYwUCMQR524XTGzjAxKQ0f+IN9p5ReUz8AMNOmBsfqz8x+AawK/H8F8gDbwX7ppKE23LbvB4OnVCyv4dkIiBuAsq2uMMNrQ5BoRUwAyjZH2nFunUFpLVxDECYAZnQGdgIApBtCBaiyL5nTJlMlhE2vIF26UAHq7G+OCgD4RSC6AIrYWvFZ96o4VQBFaJxlwEfUhQuA2k0So/Sd4v8YWiZAeRklzItuBTR/aUZYGijBWf34B9IOLvvHt4CzaV7YTMBGhE/g0188M7oVgBnAM//aAuxtzUr38Jbd/KWzwpyEF4TvwIn6mwAjJ1zkNwtgVWBVYHoFDgR7aiXDhmwTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/res/cred_4.png
// module id = BkZ1
// module chunks = 1